(function() {
    'use strict';
    angular
        .module('functional7App')
        .factory('Cliente', Cliente);

    Cliente.$inject = ['$resource', 'DateUtils'];

    function Cliente ($resource, DateUtils) {
        var resourceUrl =  'api/clientes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fechaAlta = DateUtils.convertLocalDateFromServer(data.fechaAlta);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.fechaAlta = DateUtils.convertLocalDateToServer(copy.fechaAlta);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.fechaAlta = DateUtils.convertLocalDateToServer(copy.fechaAlta);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();
